// extracted by mini-css-extract-plugin
export default {"container":"TagFilter_container__5FM6z","select":"TagFilter_select__aLsMa","option":"TagFilter_option__-CsRC"};